import React from "react";
import { CiWavePulse1, CiMicrochip } from "react-icons/ci";
import { IoCarOutline, IoLeafOutline } from "react-icons/io5";
import { BsCameraReels } from "react-icons/bs";
import { HiMiniSignal, HiOutlineBuildingLibrary } from "react-icons/hi2";
import { GrUserWorker } from "react-icons/gr";
import { LuChevronsLeftRight, LuBuilding2 } from "react-icons/lu";
import { GiHealthNormal } from "react-icons/gi";

const SectorSkillCouncilsProgramObj = [
  {
    icon: <IoCarOutline size={40} />,
    program: "Automotive Skills Development Council",
  },
  {
    icon: <BsCameraReels size={40} />,
    program: "Media and Entertainment Sector Skill Council",
  },
  {
    icon: <CiMicrochip size={40} />,
    program: "Electronics Sector Skill Council",
  },
  {
    icon: <HiMiniSignal size={40} />,
    program: "Telecom Sector Skill Council",
  },
  {
    icon: <HiOutlineBuildingLibrary size={40} />,
    program: "Construction Sector Skill Council",
  },
  {
    icon: <GrUserWorker size={40} />,
    program: "Domestic Workers Skill Council of India",
  },
  {
    icon: <IoLeafOutline size={40} />,
    program: "Skill Council for Green Jobs",
  },
  {
    icon: <CiWavePulse1 size={40} />,
    program: "Healthcare Sector Council",
  },
  {
    icon: <GiHealthNormal size={40} />,
    program: "Beauty and Wellness Sector Skill Council",
  },
  {
    icon: <LuBuilding2 size={40} />,
    program: "Management & Enterpreneurship and Professional Skill Council",
  },
  {
    icon: <LuChevronsLeftRight size={40} />,
    program: "NASSCOM",
  },
];

const divStyle = {
  color: "#183b56",
};

const SectorSkillCouncils = () => {
  return (
    <div className="">
      <h3 className="title-styling header fw-medium pb-3" style={divStyle}>
        Sector Skill Councils
      </h3>
      <div className="d-flex w-100 flex-wrap">
        {SectorSkillCouncilsProgramObj.map((obj) => {
          return (
            <div
              key={obj.program}
              className=" card border border-1 gap-5 shadow-sm hover-shadow Employabilitybody"
              style={{ transition: "all 0.3s ease" }}
            >
              <div className="w-100 h-100">
                <div
                  className="Employabilitycard"
                  // style={{ backgroundColor: "#183b56" }}
                >
                  <h2 className="">{obj?.icon}</h2>
                  <div className="flex-grow-1 Employabilitytext">
                    <h6 className="mb-0 w-fit">{obj?.program}</h6>
                  </div>
                </div>
              </div>
              <style
                dangerouslySetInnerHTML={{
                  __html: `
          .hover-shadow:hover {
            box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
            transform: translateY(-2px);
          }
        `,
                }}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default SectorSkillCouncils;
